import gql from 'graphql-tag';

export default gql`
  mutation submitSuggestionsList($suggestionsListId: ID!) {
    submitSuggestionsList(suggestionsListId: $suggestionsListId)
  }
`;
